import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SessionService } from 'src/app/core/services/session.service';
import { SuperAdminService } from '../services.service';


@Component({
  selector: 'app-superadmin-layout',
  templateUrl: './superadmin-layout.component.html',
  styleUrls: ['./superadmin-layout.component.css']
})
export class SuperadminLayoutComponent implements OnInit {

  collapsed    = false;
  userName     = '';
  userInitial  = 'S';
  companyCount = 0;

  constructor(
    private sessionService: SessionService,
    private superAdminService: SuperAdminService,
    private router: Router
  ) {}

  ngOnInit(): void {
    const session   = this.sessionService.getSession();
    this.userName   = session?.fullName ?? 'Super Admin';
    this.userInitial = this.userName.charAt(0).toUpperCase();

    // Load company count for sidebar badge
    this.superAdminService.getCompanies().subscribe({
      next: companies => this.companyCount = companies.length
    });
  }

  logout(): void {
    this.sessionService.clearSession();
    this.router.navigate(['/auth/login']);
  }
}